module.exports = __webpack_public_path__ + "static/media/frame-big-cyan.2452e273.svg";